<template>
  <div>
    <div class="ui error message" v-if="showErrors">
      <ul class="list">
        <li class="item" v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <form id="create-content-form" class="ui form">
      <vue-dropzone
        @vdropzone-file-added="onInput"
        @vdropzone-removed-file="clear"
        id="dropzone"
        :options="dropzoneOptions"
        :useCustomSlot="true"
      >
        <div class="dropzone-custom-content">
          <h3 class="ui header">Drag and Drop an MP4 file to upload content!</h3>
          <div>...or click to select your MP4 file from your computer</div>
        </div>
      </vue-dropzone>
      <div class="field">
        <label>Language <span class="ui red text">*</span></label>
        <select data-testid="language" v-model="newValue.language" @change="$emit('validChange', newValue.language !== -1)">
          <option
            v-for="lang of languages"
            :key="lang.id"
            :value="lang.id">
              {{ lang.label }}
          </option>
        </select>
      </div>
      <div class="ui field">
        <label>Title</label>
        <div class="ui input">
          <input data-testid="title" type="text" v-model="newValue.title" />
        </div>
      </div>
      <div class="ui field">
        <label>Description</label>
        <textarea data-testid="description" rows="8" v-model="newValue.description" />
      </div>
    </form>
  </div>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import languages from '@/assets/languages.json';
const vueDropzone = require('vue2-dropzone');

export default {
  name: 'CreateContentForm',
  components: {
    vueDropzone,
  },
  data() {
    return {
      newValue: {
        title: '',
        description: '',
        language: -1,
        duration: null,
        videoType: null,
      },
      video: null,
      errors: [],
      languages: [
        {
          id: -1,
        },
        ...languages,
      ],
      dropzoneOptions: {
        url: '#',
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: '<div class="ui button">Remove File</div>',
        maxFiles: 1,
        acceptedFiles: 'video/x-msvideo, video/x-flv, video/x-matroska, video/mp2t, text/tab-separated-values, video/mpeg, audio/mpeg, video/x-mpeq2a, video/x-mpeg, video/mp4, application/x-project, application/mxff, video/quicktime, video/webm, video/x-ms-asf, video/ms-asf',
        init: function() {
          this.on('maxfilesexceeded', function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on('error', function(file) {
            if (!file.accepted && !file.type.includes('video')) {
              this.removeFile(file);
              $('body').toast({
                class: 'error',
                message: 'Please upload a supported video file',
              });
            }
          });
        },
      },
    };
  },
  computed: {
    isDirty() {
      return this.newValue.title !== '' ||
      this.newValue.description !== '' ||
      this.newValue.language > -1 ||
      this.video !== null;
    },
    isValid() {
      return this.newValue.title &&
        this.newValue.description &&
        this.newValue.language > -1 &&
        this.video;
    },
    showErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    onInput(file) {
      const _this = this;
      if (file.type.includes('video')) {
        this.video = file;
        this.newValue.videoType = file.type;
        const vid = document.createElement('video');
        const fileURL = URL.createObjectURL(file);
        vid.src = fileURL;
        vid.onloadedmetadata = function() {
          _this.newValue.duration = (this.duration / 60);
        };
      }
    },
    clear() {
      this.video = null;
      this.newValue.duration = null;
    },
    validate() {
      this.errors = [];
      if (this.isValid) {
        return true;
      }
      if (this.newValue.title === '') {
        this.errors.push('Please enter a title');
      }
      if (this.newValue.description === '') {
        this.errors.push('Please enter a description');
      }
      if (!this.video) {
        this.errors.push('Please upload a video');
      }
      if (this.newValue.language === -1) {
        this.errors.push('Please select a language');
      }
      return false;
    },
  },
};
</script>

<style lang="less">
.vue-dropzone {
  font-family: inherit;
  margin-bottom: 1em;
  border-style: dashed;
}
.dz-progress {
  display: none;
}
.vue-dropzone>.dz-preview {
  & .dz-remove {
    width: 100%;
    margin: 0;
    left: 50%;
    transform: translate(-50%);
    border: none;
    opacity: 1;
  }
  & .dz-details {
    background-color: #1c4a53;
  }
}
</style>
